import { Typography } from "@mui/material";
import NoData from "../../../../components/noData/Nodata";
import CustomTable from "../../../../components/table/CustomTable";
import TileBox from "../../../../components/tile/TileBox";
import { useStyles } from "../style";
import TruncatedText from "./../../../../elements/TruncatedText";

const columns = [
  {
    field: "service",
    label: "Service",
    render: (row) => <TruncatedText text={row.service} maxLength={40} />,
  },
  {
    field: "amount",
    label: "Cost",
    align: "right",
    headerAlign: "right",
    render: (row) => (
      <Typography variant="body2" title={row.amount}>
        ${row.amount.toFixed(2)}
      </Typography>
    ),
  },
];

const CostReport = ({ data }) => {
  const classes = useStyles();
  return (
    <TileBox title={"Cost"}>
      {data.length > 0 ? (
        <CustomTable
          columns={columns}
          data={data}
          pagination={true}
          headerClass={classes.tableHeaderClass}
          variant="secondary"
        />
      ) : (
        <NoData />
      )}
    </TileBox>
  );
};

export default CostReport;
